<template>
  <div class="space-y-1 flex flex-row items-center">
    <label
      id="listbox-label"
      class="block leading-5 text-standard text-base pt-1"
    >
      {{ label }}
    </label>
    <div class="relative w-64">
      <span
        :class="borderhighlight"
        class="inline-block w-full borderhover "
        @click="menuOpen = !menuOpen"
      >
        <button
          type="button"
          aria-haspopup="listbox"
          aria-expanded="true"
          aria-labelledby="listbox-label"
          class="cursor-default relative w-full rounded-md bg-white pl-3 pr-10 py-2 text-left focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          <div class="flex items-center space-x-3 text-base text-standard">
            <span class="block truncate">
              {{ modelValue.label }}
            </span>
          </div>
          <span
            class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
          >
            <svg
              class="h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
            >
              <path
                d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </button>
      </span>
      <transition
        enter-active-class="transition ease-out duration-100 transform"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75 transform"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <div
          v-show="menuOpen"
          class="absolute mt-1 w-full rounded-md bg-white shadow-lg z-10"
        >
          <ul
            tabindex="-1"
            role="listbox"
            aria-labelledby="listbox-label"
            aria-activedescendant="listbox-item-3"
            class="max-h-56 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
          >
            <li
              v-for="(element, index) in elements"
              :id="'listbox-item-' + index"
              :key="element.value"
              role="option"
              :class="bghighlight"
              class="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9 hover:text-white"
              @click="setFilterValue(element)"
            >
              <div class="flex items-center space-x-3">
                <span class="font-normal block truncate">
                  {{ element.label }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
interface Entry {
    label: string
    value: string
}

export default defineNuxtComponent({
  props: {
    modelValue: {
      type: Object as PropType<Entry>,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    elements: {
      type: Array as PropType<Entry[]>,
      default: () => []
    },
    highlight: {
      type: String,
      default: 'orange'
    }
  },
  data: function() {
    return {
      menuOpen: false,
    }
  },
  computed: {
    // TODO: this is not tailwindcss friendly: those classes cannot be generated
    bghighlight: function() {
      return 'hover:bg-' + this.highlight
    },
    borderhighlight: function() {
      return 'hover:border-' + this.highlight
    }
  },
  methods: {
    setFilterValue(val: Entry) {
      this.menuOpen = false
      // this.$emit('input', val)
      this.$emit('update:modelValue', val)
    }
  }
})
</script>

<style scoped>
.borderhover{
  border-bottom:1px solid #fff;
}
/*.borderhover:hover {*/
/*  border-bottom:1px solid;*/
/*}*/
</style>
